<script setup lang="ts">
// assets
import bgMobileAvif from '@images/layouts/background_mobile.avif'
import bgMobileWebp from '@images/layouts/background_mobile.webp'
import bgDesktopAvif from '@images/layouts/background_desktop.avif'
import bgDesktopWebp from '@images/layouts/background_desktop.webp'
// components
import { AppImage } from '@UI/Images/AppImage'

defineOptions({
  name: 'LayoutBackground',
})
</script>

<template>
  <AppImage
    class="layout__background layout__background--mobile"
    :srcset="bgMobileAvif"
    :src="bgMobileWebp"
    width="1500"
    height="3040"
    alt=""
  />
  <AppImage
    class="layout__background layout__background--desktop"
    :srcset="bgDesktopAvif"
    :src="bgDesktopWebp"
    width="5760"
    height="6708"
    alt=""
  />
</template>
